import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export default class ImagesTextSlider {
	
	constructor(el) {

		this.el = el;

		this.initImagesTextSliderSwipers(el);

	} 

	initImagesTextSliderSwipers(elm){		

		const swiper = new Swiper( elm.querySelector('.swiper'), {    
			modules           : [ Navigation ],
			slidesPerView     : 4,
			loop              : false,			
			spaceBetween      : 28,
			autoHeight        : false,
			navigation      : {
				nextEl      : elm.querySelector('.swiper-button-next'),
				prevEl      : elm.querySelector('.swiper-button-prev'),
		  	},
			breakpoints       : {   
			  	10 	: {
					slidesPerView   : 1.04,          
					spaceBetween    : 12,
					autoHeight		: true,
			  	},   
			  	320 : {
					slidesPerView   : 1.04,          
					spaceBetween    : 12,
					autoHeight		: true,
			  	},  
			  	480 : {
					slidesPerView   : 1.2,          
					spaceBetween    : 20,
			  	},   
			  	640 : {
					slidesPerView   : 1.2,          
					spaceBetween    : 20,
			  	},     
			  	768 : {
					slidesPerView   : 2.2,          
					spaceBetween    : 16,
			  	},  
			  	1024 : {
					slidesPerView   : 2.3,          
					spaceBetween    : 20,
			  	},
			  	1240 : {
					slidesPerView   : 2.2,          
					spaceBetween    : 24,
			  	},
			  	1420 : {
					slidesPerView   : 2.2,          
					spaceBetween    : 32,
			  	},          
			},
		});

	}

}